<script>
import { VCard } from "vuetify/lib";

export default {
  name: "Card",
  props: {
    tile: {
      type: Boolean,
      default: true,
    },
  },
  extends: VCard,
};
</script>
